const attachmentType = {
    IMAGE: 0,
    VIDEO: 1,
    VOICE: 2,
    NONE: 3
}

export default attachmentType;